<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("deleteToken").then(() => {
      this.$router.push("/login");
    });
  }
};
</script>
